import * as React from 'react'

const SvgReverseLeftIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.33333 4.83333H9.66667C12.4281 4.83333 14.6667 7.07191 14.6667 9.83333C14.6667 12.5948 12.4281 14.8333 9.66667 14.8333H1.33333M1.33333 4.83333L4.66667 1.5M1.33333 4.83333L4.66667 8.16667"
      stroke="#344054"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgReverseLeftIcon
